export const edipData = [
  {
    name: "投诉请求",
    type: "complaint",
    edited: true,
    title: "投诉须知",
    Confirmation:
      "我承诺提出的信访事项客观真实，并对所提供材料内容的真实性负责。",
    push: "/complite",
    url: "",
  },
  {
    name: "建议征集",
    type: "proposal",
    edited: true,
    title: "建议须知",
    Confirmation:
      "我承诺提出的信访事项客观真实，并对所提供材料内容的真实性负责。",
    push: "/proposal",
    url: "",
  },
  {
    name: "查询评价",
    type: "evaluate",
    edited: true,
    url: "",
    push: "/query",
  },
  {
    name: "个人中心",
    type: "userInfo",
    edited: true,
    url: "",
    push: "/userInfo",
  },
];
